<template>
    <div
        class="visualization pay-drag-visualization"
        v-loading="loading"
        element-loading-spinner="presupuesto-loader"
    >
        <div v-show="!showDetails" class="row">
            <div class="col-sm-3">
                <div class="sidebar">
                    <!--
                    <a href="#" class="btn btn-block btn-light" :class="{active: sector === null}">Todos</a>
                    <a v-for="s in sectores" href="#" class="btn btn-block btn-light" :class="{active: sector === s}">{{s}}</a>
                    -->
                    <el-radio-group v-model="input.partida" size="medium">
                        <el-radio-button
                            :key="s.partida"
                            v-for="s in partidas"
                            :label="s.partida"
                            border
                        >
                            <div class="label">{{ s.nombre_partida }}</div>
                            <div class="count">
                                {{ numeral(s.count).format('0,0') }} Documentos
                            </div>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="col-sm-9">
                <div class="row">
                    <div class="col-sm-6">
                        <h3>
                            {{
                                find(partidas, { partida: input.partida })
                                    .nombre_partida
                            }}
                        </h3>
                    </div>
                </div>
                <stacked-bar-chart
                    :data="filteredData"
                    :dimensions="dimensions"
                    @detail-clicked="detailClicked"
                    :color="color"
                    x-axis-title="Año de pago"
                    y-axis-title="MM de pesos"
                    :scale-pow-exponent="1 / 2"
                ></stacked-bar-chart>
            </div>
        </div>
        <div v-show="showDetails">
            <a
                href="#"
                @click.prevent="
                    periodoDocumento = null;
                    periodoPago = null;
                "
                >< Volver al gráfico</a
            >
            <expenses-detail-visualization
                :where="detailWhere"
                ref="detailViz"
            ></expenses-detail-visualization>
        </div>
    </div>
</template>
<style lang="scss">
.pay-drag-visualization {
    .sidebar {
        height: 640px;
        overflow: scroll;
        .el-radio-button {
            display: block;
            .el-radio-button__inner {
                display: block;
                white-space: normal;
                border: 1px solid #d6d5d5;
                box-shadow: 0px 0px 4px rgba(188, 188, 188, 0.5);
                border-radius: 4px;
                background: white;
                text-align: left;
                font-size: 14px;
                .label {
                    margin-bottom: 5px;
                }
                .count {
                    color: #25af7c;
                    font-weight: bold;
                }
            }
            &.is-active {
                .el-radio-button__inner {
                    background: inherit;
                    color: inherit;
                    box-shadow: 0px 0px 4px rgba(188, 188, 188, 0.5) !important;
                    .label {
                        color: #0098ff;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>
<script>
import * as d3 from 'd3';
import axios from 'axios';
import _ from 'lodash';
import numeral from 'numeral';
import StackedBarChart from '../Charts/StackedBar';
import ExpensesDetailVisualization from './ExpensesDetail';

export default {
    data: function() {
        return {
            input: {
                partida: null
            },
            periodoPago: null,
            periodoDocumento: null,
            loading: false,
            data: [],
            mode: 'chart',
            dimensions: {
                ordinal: ['periodo_documento'],
                time: ['periodo_pago']
            },
            url:
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify([
                    'partida',
                    'periodo_pago',
                    'periodo_documento'
                ]) +
                //'&where=' +
                //JSON.stringify({ partida: this.input.partida }) +
                '&where-not=' +
                JSON.stringify({
                    periodo_documento: null,
                    periodo_pago: null
                })
        };
    },
    components: {
        StackedBarChart,
        ExpensesDetailVisualization
    },
    computed: {
        partidas: function() {
            const central = [
                {
                    partida: null,
                    nombre_partida: 'GOBIERNO CENTRAL',
                    count: _.sumBy(this.data, 'count')
                }
            ];

            const partidas = _(this.data)
                .groupBy('partida')
                .map(d => {
                    return {
                        partida: d[0].partida,
                        nombre_partida: d[0].nombre_partida,
                        count: _.sumBy(d, 'count')
                    };
                })
                .value();

            return central.concat(partidas);
        },
        filteredData() {
            const filteredData = _(this.data)
                .filter(d => {
                    if (this.input.partida === null) return true;
                    return d.partida === this.input.partida;
                })
                .groupBy(d => {
                    return d.periodo_pago + '-' + d.periodo_documento;
                })
                .map(d => {
                    return {
                        periodo_pago: d[0].periodo_pago,
                        periodo_documento: d[0].periodo_documento,
                        sum: _.sumBy(d, 'sum'),
                        count: _.sumBy(d, 'count')
                    };
                })
                .orderBy(['periodo_pago', 'periodo_documento'])
                .value();

            return filteredData;
        },
        color: function() {
            return d3.scaleOrdinal([
                '#081D58',
                '#3455DB',
                '#28A228',
                '#FE5A1D',
                '#D53E4F',
                '#49006A',
                '#FFD152',
                '#8F8F8F'
            ]);
        },
        detailWhere: function() {
            return {
                partida: this.input.partida || undefined,
                periodo_pago: this.periodoPago,
                periodo_documento: this.periodoDocumento
            };
        },
        showDetails() {
            return this.periodoPago && this.periodoDocumento;
        }
    },

    methods: {
        numeral: numeral,
        find: _.find,
        refreshData: function() {
            this.loading = true;
            axios.get(this.url).then(response => {
                this.loading = false;

                this.data = _(response.data)
                    .filter(d => {
                        return d.periodo_pago !== d.periodo_documento;
                    })
                    .value();

                //Normalizamos los valores
                /*
                const totals = _(this.data)
                    .groupBy('periodo_pago')
                    .mapValues(d => {
                        return _.sumBy(d, 'sum');
                    })
                    .value();*/

                /*
                const max = _(totals)
                    .values()
                    .max();
                */

                /*
                _(this.data).forEach(d => {
                    d.sum = d.sum / totals[d.periodo_pago];
                });
                */
            });
        },
        detailClicked: function({ periodo_pago, periodo_documento }) {
            this.periodoPago = periodo_pago;
            this.periodoDocumento = periodo_documento;
        }
    },
    mounted: function() {
        this.refreshData();
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/PayDrag.vue